module.exports = __webpack_public_path__ + "static/img/8.2dd5e29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/8.png
// module id = g7OD
// module chunks = 0